import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { ClipboardX } from "lucide-react";
import { formatDate } from "@/lib/format";
import type { AccountDeletionSurveyItem } from "@/types/account-deletion-survey";
import { ACCOUNT_DELETION_REASON_LABEL } from "@/types/account-deletion-survey";
import type { PaginationMeta } from "@/types/common";
import type { UsePaginationReturn } from "@/hooks/use-pagination";
import { AccountDeletionSurveyPagination } from "./account-deletion-survey-pagination";

interface Props {
  data: AccountDeletionSurveyItem[];
  meta: PaginationMeta;
  pagination: UsePaginationReturn;
}

export function AccountDeletionSurveyTable({ data, meta, pagination }: Props) {
  if (data.length === 0) {
    return (
      <div className="rounded-lg border p-12 text-center space-y-3">
        <ClipboardX className="mx-auto h-10 w-10 text-muted-foreground" />
        <p className="text-muted-foreground">탈퇴 설문 응답이 없습니다.</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="overflow-x-auto rounded-md border">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="w-[240px]">이메일</TableHead>
              <TableHead className="w-[140px]">가입일</TableHead>
              <TableHead className="w-[140px]">탈퇴일</TableHead>
              <TableHead className="w-[160px]">사유</TableHead>
              <TableHead>상세 메시지</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.map((item) => (
              <TableRow key={item.surveyId}>
                <TableCell>
                  <span className="block max-w-[220px] truncate text-sm font-medium">
                    {item.userEmail}
                  </span>
                </TableCell>
                <TableCell className="whitespace-nowrap text-sm text-muted-foreground">
                  {formatDate(item.userCreatedAt, { format: "short" })}
                </TableCell>
                <TableCell className="whitespace-nowrap text-sm text-muted-foreground">
                  {formatDate(item.withdrawnAt, { format: "short" })}
                </TableCell>
                <TableCell>
                  <Badge variant="secondary">
                    {ACCOUNT_DELETION_REASON_LABEL[item.reason] ?? item.reason}
                  </Badge>
                </TableCell>
                <TableCell>
                  {item.detail ? (
                    <p className="line-clamp-2 max-w-[520px] text-sm">{item.detail}</p>
                  ) : (
                    <span className="text-xs text-muted-foreground">-</span>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      <AccountDeletionSurveyPagination meta={meta} pagination={pagination} />
    </div>
  );
}
